module.exports = __webpack_public_path__ + "img/registrate.0b9e1776.png";